document.addEventListener("DOMContentLoaded", () => {
  const form = document.getElementById("product-form");
  if (!form) return;

  const btn = form.querySelector("button[type='submit']");
  const hiddenInput = form.querySelector("input[type='hidden'][name='id']");
  const variantRadios = Array.from(form.querySelectorAll('input[type="radio"][name="id"]'));


  variantRadios.forEach(radio => {
    radio.addEventListener("change", async (e) => {
      const variantId = e.target.value;
      hiddenInput.value = variantId;
    });
  });

  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    if (btn) btn.disabled = true;

    const formData = new FormData(form);

    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        body: formData
      });

      if (!res.ok) {
        const errBody = await res.json().catch(() => ({}));
        throw new Error(errBody.description || res.statusText || "Zum Warenkorb hinzufügen fehlgeschlagen");
      }

      if (btn) {
        btn.textContent = "Bereits im Warenkorb";
        btn.disabled = true;
      }
      variantRadios.forEach(r => r.disabled = true);

      const cartRes = await fetch("/cart.js");
      const cartData = await cartRes.json();

      const headerIcons = document.querySelector(".header__icons a");
      let cartCountEl = headerIcons.querySelector("sup");

      if (cartData.item_count > 0) {
        if (!cartCountEl) {
          cartCountEl = document.createElement("sup");
          headerIcons.appendChild(cartCountEl);
        }
        cartCountEl.textContent = cartData.item_count;
      } else {
        if (cartCountEl) {
          cartCountEl.remove();
        }
      }

    } catch (err) {
      console.error("Fehler beim Hinzufügen:", err);
    }
  });

  document.addEventListener('cart:updated', e => {
    const cart = e.detail.cart;
    if (!cart) return;

    const variantIds = variantRadios.map(radio => parseInt(radio.value, 10));
    const productInCart = cart.items.some(item => variantIds.includes(item.variant_id));

    if (productInCart) {
      btn.disabled = true;
      btn.textContent = "Bereits im Warenkorb";
      variantRadios.forEach(r => r.disabled = true);
    } else {
      btn.disabled = false;
      btn.textContent = "In den Warenkorb legen";
      variantRadios.forEach(r => r.disabled = false);
    }
  });
});